import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginForm from "@/views/LoginForm";
import Dispatch from "@/views/Dispatch";
import Courier from "@/views/Courier";
import CourierRegistration from "@/views/CourierRegistration";
import ShowStock from "@/views/ShowStock";
import ShowStockList from "@/components/ShowStockList";
import PaymentScreen from "@/views/PaymentScreen";
import PaymentDetails from "@/views/PaymentDetails";
import ScanPage from "@/components/ScanPage";
import Deposite from "@/views/Deposite";
import TrackingScreen from "@/components/TrackingScreen";
import Yango from "@/views/Yango";
import Success from "@/components/Success";
import otpForm from "@/views/otpForm";

Vue.use(VueRouter)

const routes = [

    {
        path: '/login',
        name: "LoginForm",
        component: LoginForm,
    },
    {
        path: '/dispatch',
        name: "Dispatch",
        component: Dispatch,
    },
    {
        path: '/courier',
        name: "Courier",
        component: Courier,
    },
    {
        path: '/courier-registration',
        name: "CourierRegistration",
        component: CourierRegistration,
    },
    {
        path: '/show-details',
        name: "ShowStock",
        component: ShowStock,
    },
    {
        path: '/show-stock',
        name: "ShowStockList",
        component: ShowStockList,
    },
    {
        path: '/payment-screen',
        name: "PaymentScreen",
        component: PaymentScreen,
    },
    {
        path: '/payment-details',
        name: "PaymentDetails",
        component: PaymentDetails,
    },
    {
        path: '/scan-code',
        name: "ScanPage",
        component: ScanPage,
    },
    {
        path: '/deposite',
        name: "Deposite",
        component: Deposite,
    },
    {
        path: '/tracking',
        name: " TrackingScreen",
        component:  TrackingScreen,
    },
    {
        path: '/yango',
        name: "Yango",
        component:  Yango,
    },
    {
        path: '/success',
        name: "Success",
        component:  Success,
    },
    {
        path: '/otpForm',
        name: "otpForm",
        component:  otpForm,
    },
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
